import {useIsMobileByScreen} from 'core/hooks/useIsMobileByScreen';
import {useIsTabletByScreen} from 'core/hooks/useIsTabletByScreen';
import {useEffect, useState} from 'react';

const offsetValues = {
    DESKTOP: 200,
    TABLET: 181,
    MOBILE: 64,
};

export const useReviewScrollOffset = () => {
    const [offset, setOffset] = useState(0);
    const isTablet = useIsTabletByScreen();
    const isMobile = useIsMobileByScreen();

    useEffect(() => {
        let offsetValue = offsetValues.DESKTOP;

        if (isTablet) {
            offsetValue = offsetValues.TABLET;
        }

        if (isMobile) {
            offsetValue = offsetValues.MOBILE;
        }

        setOffset(offsetValue);
    }, [isTablet, isMobile]);

    return offset;
};
